export const blogList = [
  {
    id: 1,
    title: 'Bora Bora, French Polynesia ',
    category: 'French Polynesia',
    subCategory: ['traveler', 'explorer', 'vacations'],
    description:
      "The relatively small island of Bora Bora is an activity giant, offering visitors the chance to experience a 4x4 safari, sunbathe and swim at white sandy beaches, dive in a natural underwater park among fish and corals, experience thrilling shark feedings, or circle the turquoise lagoon by boat. Fall captive to this lush gem of a Polynesian island by sharing an intimate midnight dinner on the beach; visiting the Lagoonarium, the Diving Centre, the Coral Gardens or the Leopard Rays Trench; or taking it all in from the lofty heights of 2,300-foot Mount Otemanu.",
    authorName: 'John Doe',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover: '/assets/images/1.jpg',
  },
  {
    id: 2,
    title: 'London, England',
    category: 'England',
    subCategory: ['vacation', 'holidays', 'traveler'],
    description:
      "London is layered with history, where medieval and Victorian complement a rich and vibrant modern world. The Tower of London and Westminster neighbour local pubs and markets, and time-worn rituals like the changing of the guards take place as commuters rush to catch the Tube. It’s a place where travellers can time-hop through the city, and when they’re weary, do as Londoners do and grab a “cuppa” tea.",
    authorName: 'John Doe',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover: '/assets/images/2.jpg',
  },
  {
    id: 3,
    title: 'Hawaii',
    category: 'United States',
    subCategory: ['vacation', 'holidays', 'traveler'],
    description:
      "For many, the word 'holiday' conjures images of sunbathing on a sunny beach, paddling in a dazzling blue ocean, napping under coconut trees—in other words, Hawaii. But travellers who can pull themselves away from the 50th state's stunning beaches will find so much more. From volcanic landscapes to hidden waterfalls and epic expeditions, a Hawaiian getaway can go in a dozen different directions.",
    authorName: 'John Doe',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover: '/assets/images/3.jpg',
  },
  {
    id: 4,
    title: 'Bali',
    category: 'Indonesia',
    subCategory: ['traveler', 'explorer', 'vacations'],
    description:
      "No island has enchanted travellers quite like Bali. Less than half the size of Hawaii’s big island, Bali manages to pack countless adventures into one small package. Dazzling beaches beckon the sun seekers and surfers along the island’s southwest coast, while ancient temples and a thriving wellness scene draw travellers inland to Ubud.",
    authorName: 'John Doe',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover: '/assets/images/4.jpg',
  },
  {
    id: 5,
    title: 'Jaipur',
    category: 'India',
    subCategory: ['vacation', 'holidays', 'traveler'],
    description:
      "If you take one look at the glorious stucco buildings that line Jaipur's wide streets, you'll understand why this is nicknamed 'The Pink City.' Spend your days exploring City Palace, Hawa Mahal, and Amber and Jaigarh forts. And if you're looking for a unique souvenir, head to one of the bazaars, where you can pick up a pair of camel-leather slippers.",
    authorName: 'John Doe',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover: '/assets/images/5.jpg',
  },
  {
    id: 6,
    title: 'Las Vegas, Nevada',
    category: 'United States',
    subCategory: ['beaches', 'sea', 'holidays'],
    description:
      "Whether you’re a low-key lounger or a high-roller, Las Vegas is a holiday win. Eat your way across Michelin-starred restaurants, try your luck at famed casinos, or take in a spectacular show. Just wandering the Strip is enough to get your endorphins in overdrive.",
    authorName: 'John Doe',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover:
      '/assets/images/6.jpg',
  },
  {
    id: 7,
    title: 'Copenhagen',
    category: 'Denmark',
    subCategory: ['vacation', 'holidays', 'traveler'],
    description:
      "Copenhagen is one of Europe’s oldest and most popular cities. It’s also one of the cleanest and most metropolitan. The dynamic Danish capital features progressive modern architecture, the must-visit Tivoli Gardens amusement park, stunning palaces, and all the activities and amenities you would expect in a world-class destination.",
    authorName: 'John Doe',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover: '/assets/images/7.jpg',
  },
  {
    id: 8,
    title: 'Head To Beach Bars',
    category: 'Greece',
    subCategory: ['traveler', 'explorer', 'vacations'],
    description:
      "Greece has the longest coastline in Europe and is the southernmost country in Europe. The mainland has rugged mountains, forests, and lakes, but the country is well known for the thousands of islands dotting the blue Aegean Sea to the east, the Mediterranean Sea to the south, and the Ionian Sea to the west.",
    authorName: 'John Doe',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover: '/assets/images/8.jpg',
  },
  {
    id: 9,
    title: 'Lisbon',
    category: 'Portugal',
    subCategory: ['traveler', 'explorer', 'vacations'],
    description:
      "Nestled among seven hills, this immensely walkable city offers an enchanting alternative to Europe’s more popular capitals. With a lively nightlife scene, festive markets, and vibrant museums, Lisbon provides plenty of options to burn off a few mandatory glasses of Porto, a generous serving of bacalhau, and days’ worth of pastéis de nata.",
    authorName: 'John Doe',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover: '/assets/images/9.jpg',
  },
  {
    id: 10,
    title: 'Santorini',
    category: 'Greece',
    subCategory: ['vacation', 'holidays', 'traveler'],
    description:
      "Even if you’ve never been to this Cyclades island in the Aegean Sea, you’d still recognise it immediately—its candy-coloured houses carved into cliffs, sapphire waters, and chalk-white buildings topped with cobalt-blue domes. Roam the peaceful black-sand beaches or wander the streets of a provincial village like Imerovigli. Beautiful Oia is world famous for its sunsets, which seem to dial through a kaleidoscope of colours before fading to starlight.",
    authorName: 'John Doe',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover: '/assets/images/10.jpg',
  },
  {
    id: 11,
    title: 'Kerala',
    category: 'India',
    subCategory: ['traveler', 'explorer', 'vacations'],
    description:
      "India’s millennia-old natural medicine, Ayurveda, is the guiding force in southern state Kerala’s famed health resorts. To rejuvenate in luxurious surrounds, try 50-acre oasis Kairali Ayurvedic Health Resort’s authentic ayurvedic healing with aromatherapy, massage, essential oils and yoga.",
    authorName: 'John Doe',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover: '/assets/images/11.jpg',
  },
  {
    id: 12,
    title: 'Ladakh',
    category: 'India',
    subCategory: ['vacation', 'holidays', 'traveler'],
    description:
      "Bounded by the Karakoram and Himalayan mountains, Ladhak is the largest province in the state of Jammu and Kashmir. The landscape of Ladhak, a high altitude desert, is defined by craggy, barren cliffs and plateaus. Ladhak is a favorite among adventure sports enthusiasts, offering unique adventures in trekking, mountaineering and white water rafting.",
    authorName: 'John Doe',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover: '/assets/images/12.jpg',
  },
  {
    id: 13,
    title: 'Rome',
    category: 'Italy',
    subCategory: ['traveler', 'explorer', 'vacations'],
    description:
      "The sprawling city of Rome remains one of the most significant stops in the world, thanks to its seamless blend of Old World wonders and modern delights. The ruins of the Colosseum, her iconic fountains, lazy wanders through cobblestone streets with gelato in hand: All this and more beckon. Rome is a winding, spectacular city full of places to discover.",
    authorName: 'John Doe',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover: '/assets/images/13.jpg',
  },
];
